import { Id } from '@nextforce/api'
import { ListItem, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import moment from 'moment'
import { StoreUserNonAvailability } from 'non_availability/queries/types'
import React from 'react'
import { FlatList, Platform, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { EmptyAvailability } from 'shared/components/non_availability/empty_availability'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { UserAvatar } from 'shared/components/user/user_avatar'

interface Props {
  nonAvailabilities: StoreUserNonAvailability[] | undefined
  onPressPendingRequest(requestId?: Id): void
  goToNonAvailabilityDetails(requestId?: Id): void
}

export function NonAvailabilityListView({
  nonAvailabilities,
  onPressPendingRequest,
  goToNonAvailabilityDetails,
}: Props) {
  const styles = useStyles()

  if (!nonAvailabilities) return null

  if (nonAvailabilities.length === 0) {
    return <EmptyAvailability />
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <FlatList
          style={styles.list}
          data={nonAvailabilities}
          keyExtractor={item => String(item.id)}
          renderItem={({ item }) => (
            <NonAvailabilityRow
              nonAvailability={item}
              onPressPendingRequest={onPressPendingRequest}
              goToNonAvailabilityDetails={goToNonAvailabilityDetails}
            />
          )}
        />
      </View>
    </SafeAreaView>
  )
}

interface NonAvailabilityRowProps {
  nonAvailability: StoreUserNonAvailability
  onPressPendingRequest(requestId?: Id): void
  goToNonAvailabilityDetails(requestId?: Id): void
}

function NonAvailabilityRow({
  nonAvailability,
  onPressPendingRequest,
  goToNonAvailabilityDetails,
}: NonAvailabilityRowProps) {
  const styles = useStyles()

  if (!nonAvailability.user) return

  const { user, status, changedAt } = nonAvailability
  return (
    <PressableOpacity
      onPress={
        Platform.OS === 'web'
          ? null
          : () => goToNonAvailabilityDetails(nonAvailability.id)
      }
    >
      <ListItem containerStyle={styles.listItem}>
        <UserAvatar user={user} size="medium" showAvatarIfNoPhone={true} />
        <ListItem.Content>
          <ListItem.Title>{`${user.firstName} ${user.lastName}`}</ListItem.Title>
        </ListItem.Content>
        <ListItem.Content>
          <ListItem.Title
            style={status === 'PENDING' ? styles.seeRequestText : {}}
            onPress={() => onPressPendingRequest(nonAvailability.id)}
          >
            {status === 'APPROVED' && changedAt
              ? moment(changedAt).format('MMM DD, YYYY')
              : status === 'PENDING'
              ? t('seeRequest')
              : null}
          </ListItem.Title>
        </ListItem.Content>
      </ListItem>
    </PressableOpacity>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
  },
  list: {
    paddingVertical: 10,
  },
  pagerView: {
    flex: 1,
  },
  page: {
    padding: 20,
    backgroundColor: '#fff',
  },
  userName: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 0.6,
    paddingLeft: 16,
    paddingRight: 0,
  },
  seeRequestText: {
    color: theme.colors?.primary,
  },
}))
